// eslint-disable-next-line import/prefer-default-export
export const DATE_FORMAT = "DD-MM-YYYY";
export const DATE_UI_FORMAT = "DD MMM YYYY";
export const DATE_API_FORMAT = "YYYY-MM-DD";
export const DATE_UI_FULL_MONTH_FORMAT = "DD MMMM YYYY";
export const DATE_UI_DAY_FORMAT = "DD";
export const DATE_UI_MONTH_FORMAT = "MMMM";
export const DATE_UI_YEAR_FORMAT = "YYYY";
